// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animation-container {
	display: block;
	position: relative;
	width: 800px;
	max-width: 100%;
	margin: 150px auto 0;
	
	.lightning-container {
		position: absolute;
		top: 50%;
		left: 0;
		display: flex;
		transform: translateY(-50%);
		
		.lightning {
			position: absolute;
			display: block;
			height: 12px;
			width: 12px;
			border-radius: 12px;
			transform-origin: 6px 6px;

			animation-name: woosh;
			animation-duration: 1.5s;
			animation-iteration-count: infinite;
			animation-timing-function: cubic-bezier(0.445, 0.050, 0.550, 0.950);
			animation-direction: alternate;

			&.white {
				background-color: white;
				box-shadow: 0px 50px 50px 0px transparentize(white, 0.7);
			}

			&.red {
				background-color: #fc7171;
				box-shadow: 0px 50px 50px 0px transparentize(#fc7171, 0.7);
				animation-delay: 0.2s;
			}
		}
	}
	
	
	.boom-container {
		position: absolute;
		display: flex;
		width: 80px;
		height: 80px;
		text-align: center;
		align-items: center;
		transform: translateY(-50%);
    left: 200px;
    top: -145px;
		
		.shape {
			display: inline-block;
			position: relative;
			opacity: 0;
			transform-origin: center center;
			
			&.triangle {
				width: 0;
				height: 0;
				border-style: solid;
				transform-origin: 50% 80%;
				animation-duration: 1s;
				animation-timing-function: ease-out;
				animation-iteration-count: infinite;
				margin-left: -15px;
				border-width: 0 2.5px 5px 2.5px;
				border-color: transparent transparent #42e599 transparent;
				animation-name: boom-triangle;
				
				&.big {
					margin-left: -25px;
					border-width: 0 5px 10px 5px;
					border-color: transparent transparent #fade28 transparent;
					animation-name: boom-triangle-big;
				}
			}
			
			&.disc {
				width: 8px;
				height: 8px;
				border-radius: 100%;
				background-color: #d15ff4;
				animation-name: boom-disc;
				animation-duration: 1s;
				animation-timing-function: ease-out;
				animation-iteration-count: infinite;
			}
			
			&.circle {
				width: 20px;
				height: 20px;
				animation-name: boom-circle;
				animation-duration: 1s;
				animation-timing-function: ease-out;
				animation-iteration-count: infinite;
				border-radius: 100%;
				margin-left: -30px;
				
				&.white {
					border: 1px solid white;
				}
				
				&.big {
					width: 40px;
					height: 40px;
					margin-left: 0px;
					
					&.white {
						border: 2px solid white;
					}
				}
			}
			
			&:after {
				background-color: rgba(178, 215, 232, 0.2);
			}
		}
		
		.shape {
			&.triangle, &.circle, &.circle.big, &.disc {
				animation-delay: .38s;
				animation-duration: 3s;
			}
			
			&.circle {
				animation-delay: 0.6s;
			}
		}
		
		&.second {
			left: 485px;
			top: 155px;
			.shape {
				&.triangle, &.circle, &.circle.big, &.disc {
					animation-delay: 1.9s;
				}
				&.circle {
					animation-delay: 2.15s;
				}
			}
		}
	}
}

@keyframes woosh {
	0% {
		width: 12px;
		transform: translate(0px, 0px) rotate(-35deg);
	}
	15% {
		width: 50px;
	}
	30% {
		width: 12px;
		transform: translate(214px, -150px) rotate(-35deg);
	}
	30.1% {
		transform: translate(214px, -150px) rotate(46deg);
	}
	50% {
		width: 110px;
	}
	70% {
		width: 12px;
		transform: translate(500px, 150px) rotate(46deg);
	}
	70.1% {
		transform: translate(500px, 150px) rotate(-37deg);
	}
	
	85% {
		width: 50px;
	}
	100% {
		width: 12px;
		transform: translate(700px, 0) rotate(-37deg);
	}
}

@keyframes boom-circle {
	0% {
		opacity: 0;
	}
	5% {
		opacity: 1;
	}
	30% {
		opacity: 0;
		transform: scale(3);
	}
	100% {
	}
}

@keyframes boom-triangle-big {
	0% {
		opacity: 0;
	}
	5% {
		opacity: 1;
	}
	
	40% {
		opacity: 0;
		transform: scale(2.5) translate(50px, -50px) rotate(360deg);
	}
	100% {
	}
}

@keyframes boom-triangle {
	0% {
		opacity: 0;
	}
	5% {
		opacity: 1;
	}
	
	30% {
		opacity: 0;
		transform: scale(3) translate(20px, 40px) rotate(360deg);
	}
	
	100% {
	}
}

@keyframes boom-disc {
	0% {
		opacity: 0;
	}
	5% {
		opacity: 1;
	}
	40% {
		opacity: 0;
		transform: scale(2) translate(-70px, -30px);
	}
	100% {
		
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroBgAnimation/HeroBgAnimation.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,oBAAoB;;CAEpB;EACC,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,2BAA2B;;EAE3B;GACC,kBAAkB;GAClB,cAAc;GACd,YAAY;GACZ,WAAW;GACX,mBAAmB;GACnB,yBAAyB;;GAEzB,qBAAqB;GACrB,wBAAwB;GACxB,mCAAmC;GACnC,mEAAmE;GACnE,8BAA8B;;GAE9B;IACC,uBAAuB;IACvB,wDAAwD;GACzD;;GAEA;IACC,yBAAyB;IACzB,0DAA0D;IAC1D,qBAAqB;GACtB;EACD;CACD;;;CAGA;EACC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;IACzB,WAAW;IACX,WAAW;;EAEb;GACC,qBAAqB;GACrB,kBAAkB;GAClB,UAAU;GACV,+BAA+B;;GAE/B;IACC,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mCAAmC;IACnC,mCAAmC;IACnC,kBAAkB;IAClB,+BAA+B;IAC/B,yDAAyD;IACzD,6BAA6B;;IAE7B;KACC,kBAAkB;KAClB,4BAA4B;KAC5B,yDAAyD;KACzD,iCAAiC;IAClC;GACD;;GAEA;IACC,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,mCAAmC;IACnC,mCAAmC;GACpC;;GAEA;IACC,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,mCAAmC;IACnC,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;;IAElB;KACC,uBAAuB;IACxB;;IAEA;KACC,WAAW;KACX,YAAY;KACZ,gBAAgB;;KAEhB;MACC,uBAAuB;KACxB;IACD;GACD;;GAEA;IACC,0CAA0C;GAC3C;EACD;;EAEA;GACC;IACC,qBAAqB;IACrB,sBAAsB;GACvB;;GAEA;IACC,qBAAqB;GACtB;EACD;;EAEA;GACC,WAAW;GACX,UAAU;GACV;IACC;KACC,qBAAqB;IACtB;IACA;KACC,sBAAsB;IACvB;GACD;EACD;CACD;AACD;;AAEA;CACC;EACC,WAAW;EACX,6CAA6C;CAC9C;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;EACX,kDAAkD;CACnD;CACA;EACC,iDAAiD;CAClD;CACA;EACC,YAAY;CACb;CACA;EACC,WAAW;EACX,gDAAgD;CACjD;CACA;EACC,iDAAiD;CAClD;;CAEA;EACC,WAAW;CACZ;CACA;EACC,WAAW;EACX,6CAA6C;CAC9C;AACD;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;EACV,mBAAmB;CACpB;CACA;CACA;AACD;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;EACV,2DAA2D;CAC5D;CACA;CACA;AACD;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;EACV,wDAAwD;CACzD;;CAEA;CACA;AACD;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;EACV,2CAA2C;CAC5C;CACA;;CAEA;AACD","sourcesContent":[".animation-container {\n\tdisplay: block;\n\tposition: relative;\n\twidth: 800px;\n\tmax-width: 100%;\n\tmargin: 150px auto 0;\n\t\n\t.lightning-container {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 0;\n\t\tdisplay: flex;\n\t\ttransform: translateY(-50%);\n\t\t\n\t\t.lightning {\n\t\t\tposition: absolute;\n\t\t\tdisplay: block;\n\t\t\theight: 12px;\n\t\t\twidth: 12px;\n\t\t\tborder-radius: 12px;\n\t\t\ttransform-origin: 6px 6px;\n\n\t\t\tanimation-name: woosh;\n\t\t\tanimation-duration: 1.5s;\n\t\t\tanimation-iteration-count: infinite;\n\t\t\tanimation-timing-function: cubic-bezier(0.445, 0.050, 0.550, 0.950);\n\t\t\tanimation-direction: alternate;\n\n\t\t\t&.white {\n\t\t\t\tbackground-color: white;\n\t\t\t\tbox-shadow: 0px 50px 50px 0px transparentize(white, 0.7);\n\t\t\t}\n\n\t\t\t&.red {\n\t\t\t\tbackground-color: #fc7171;\n\t\t\t\tbox-shadow: 0px 50px 50px 0px transparentize(#fc7171, 0.7);\n\t\t\t\tanimation-delay: 0.2s;\n\t\t\t}\n\t\t}\n\t}\n\t\n\t\n\t.boom-container {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\twidth: 80px;\n\t\theight: 80px;\n\t\ttext-align: center;\n\t\talign-items: center;\n\t\ttransform: translateY(-50%);\n    left: 200px;\n    top: -145px;\n\t\t\n\t\t.shape {\n\t\t\tdisplay: inline-block;\n\t\t\tposition: relative;\n\t\t\topacity: 0;\n\t\t\ttransform-origin: center center;\n\t\t\t\n\t\t\t&.triangle {\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\t\t\t\tborder-style: solid;\n\t\t\t\ttransform-origin: 50% 80%;\n\t\t\t\tanimation-duration: 1s;\n\t\t\t\tanimation-timing-function: ease-out;\n\t\t\t\tanimation-iteration-count: infinite;\n\t\t\t\tmargin-left: -15px;\n\t\t\t\tborder-width: 0 2.5px 5px 2.5px;\n\t\t\t\tborder-color: transparent transparent #42e599 transparent;\n\t\t\t\tanimation-name: boom-triangle;\n\t\t\t\t\n\t\t\t\t&.big {\n\t\t\t\t\tmargin-left: -25px;\n\t\t\t\t\tborder-width: 0 5px 10px 5px;\n\t\t\t\t\tborder-color: transparent transparent #fade28 transparent;\n\t\t\t\t\tanimation-name: boom-triangle-big;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t&.disc {\n\t\t\t\twidth: 8px;\n\t\t\t\theight: 8px;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tbackground-color: #d15ff4;\n\t\t\t\tanimation-name: boom-disc;\n\t\t\t\tanimation-duration: 1s;\n\t\t\t\tanimation-timing-function: ease-out;\n\t\t\t\tanimation-iteration-count: infinite;\n\t\t\t}\n\t\t\t\n\t\t\t&.circle {\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tanimation-name: boom-circle;\n\t\t\t\tanimation-duration: 1s;\n\t\t\t\tanimation-timing-function: ease-out;\n\t\t\t\tanimation-iteration-count: infinite;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tmargin-left: -30px;\n\t\t\t\t\n\t\t\t\t&.white {\n\t\t\t\t\tborder: 1px solid white;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t&.big {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tmargin-left: 0px;\n\t\t\t\t\t\n\t\t\t\t\t&.white {\n\t\t\t\t\t\tborder: 2px solid white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t&:after {\n\t\t\t\tbackground-color: rgba(178, 215, 232, 0.2);\n\t\t\t}\n\t\t}\n\t\t\n\t\t.shape {\n\t\t\t&.triangle, &.circle, &.circle.big, &.disc {\n\t\t\t\tanimation-delay: .38s;\n\t\t\t\tanimation-duration: 3s;\n\t\t\t}\n\t\t\t\n\t\t\t&.circle {\n\t\t\t\tanimation-delay: 0.6s;\n\t\t\t}\n\t\t}\n\t\t\n\t\t&.second {\n\t\t\tleft: 485px;\n\t\t\ttop: 155px;\n\t\t\t.shape {\n\t\t\t\t&.triangle, &.circle, &.circle.big, &.disc {\n\t\t\t\t\tanimation-delay: 1.9s;\n\t\t\t\t}\n\t\t\t\t&.circle {\n\t\t\t\t\tanimation-delay: 2.15s;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@keyframes woosh {\n\t0% {\n\t\twidth: 12px;\n\t\ttransform: translate(0px, 0px) rotate(-35deg);\n\t}\n\t15% {\n\t\twidth: 50px;\n\t}\n\t30% {\n\t\twidth: 12px;\n\t\ttransform: translate(214px, -150px) rotate(-35deg);\n\t}\n\t30.1% {\n\t\ttransform: translate(214px, -150px) rotate(46deg);\n\t}\n\t50% {\n\t\twidth: 110px;\n\t}\n\t70% {\n\t\twidth: 12px;\n\t\ttransform: translate(500px, 150px) rotate(46deg);\n\t}\n\t70.1% {\n\t\ttransform: translate(500px, 150px) rotate(-37deg);\n\t}\n\t\n\t85% {\n\t\twidth: 50px;\n\t}\n\t100% {\n\t\twidth: 12px;\n\t\ttransform: translate(700px, 0) rotate(-37deg);\n\t}\n}\n\n@keyframes boom-circle {\n\t0% {\n\t\topacity: 0;\n\t}\n\t5% {\n\t\topacity: 1;\n\t}\n\t30% {\n\t\topacity: 0;\n\t\ttransform: scale(3);\n\t}\n\t100% {\n\t}\n}\n\n@keyframes boom-triangle-big {\n\t0% {\n\t\topacity: 0;\n\t}\n\t5% {\n\t\topacity: 1;\n\t}\n\t\n\t40% {\n\t\topacity: 0;\n\t\ttransform: scale(2.5) translate(50px, -50px) rotate(360deg);\n\t}\n\t100% {\n\t}\n}\n\n@keyframes boom-triangle {\n\t0% {\n\t\topacity: 0;\n\t}\n\t5% {\n\t\topacity: 1;\n\t}\n\t\n\t30% {\n\t\topacity: 0;\n\t\ttransform: scale(3) translate(20px, 40px) rotate(360deg);\n\t}\n\t\n\t100% {\n\t}\n}\n\n@keyframes boom-disc {\n\t0% {\n\t\topacity: 0;\n\t}\n\t5% {\n\t\topacity: 1;\n\t}\n\t40% {\n\t\topacity: 0;\n\t\ttransform: scale(2) translate(-70px, -30px);\n\t}\n\t100% {\n\t\t\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
